import { useAppSelector } from "./store/hooks";
import { selectActiveObject } from "./store/reducers/deviceLinkingAppStoreSlice";
import ActiveObjectDetailedInfo from "./ActiveObjectDetailedInfo";
import DevicesAtLocationList from "./DevicesAtLocationList";
import AddOrEditDeviceForm from "./AddOrEditDeviceForm";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    controlPanelCard: {
        borderRadius: "10px",
        border: "1px solid black",
        padding: "15px",
        backgroundColor: "white",
    },
    controlPanelContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "30px",
        overflowY: "scroll",
    },
});

type DetailedViewControlPanelProps = {
    className?: string;
};

export default function DetailedViewControlPanel(props: DetailedViewControlPanelProps): JSX.Element {
    const classes = useStyles();
    return (
        <div className={`${classes.controlPanelContainer} ${props.className || ""}`}>
            <ActiveObjectDetailedInfo
                activeObject={useAppSelector(selectActiveObject)}
                className={classes.controlPanelCard}
            />
            <DevicesAtLocationList className={classes.controlPanelCard} />
            <AddOrEditDeviceForm className={classes.controlPanelCard} />
        </div>
    );
}
